module.exports = __webpack_public_path__ + "assets/img/icon-dy-mnp.8fd094c3.png";